import { Controller } from "@hotwired/stimulus"

// Simple modal controller to toggle visibility using Tailwind utility classes
// Usage:
// <div data-controller="modal">
//   <button data-action="click->modal#open">Open</button>
//   <div data-modal-target="overlay" class="hidden ...">...</div>
// </div>
//
// Optional: lazy-load a Turbo Frame when opening (set data-modal-src-value and data-modal-target="frame" on <turbo-frame>).
export default class extends Controller {
  static targets = ["overlay", "frame"]
  static values = {
    src: { type: String, default: "" }
  }

  open() {
    if (!this.hasOverlayTarget) return
    this.overlayTarget.classList.remove("hidden")

    if (this.srcValue && this.hasFrameTarget) {
      this.frameTarget.src = this.srcValue
    }
  }

  close(event) {
    if (!this.hasOverlayTarget) return

    // Allow using this method as event handler on buttons inside the modal
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    this.overlayTarget.classList.add("hidden")
  }

  // Close when clicking on background overlay (if desired)
  overlayClick(event) {
    if (event.target === this.overlayTarget) {
      this.close(event)
    }
  }

  // Utility to prevent clicks inside the dialog from bubbling to the overlay.
  stopPropagation(event) {
    if (!event) return
    event.stopPropagation()
  }
}
